import React from 'react';
import {Route, Redirect} from 'react-router-dom';

import {appStore as store} from '../../../index';


function isAllowed(path, auth) {
  return true;
}

export const ProtectedRoute = ({ component: Component, ...rest }) => {

  const buildName = process.env.REACT_APP_BUILD;
  let auth = undefined;
  let unAuthorizedLandingRoute;
  let _loginPath = window.sessionStorage.getItem("loginPath");
  if(buildName==='customer'){
    unAuthorizedLandingRoute = '/login';
  }
  else{
      unAuthorizedLandingRoute = '/logout';
  }

  //const activeStaffSession = window.sessionStorage.getItem('x-auth-token');
  //const activeUserSession = window.sessionStorage.getItem('openam-auth-token');

  if(store) {
    auth = (store.getState()).auth;
    unAuthorizedLandingRoute = auth.unAuthorizedLandingRoute ;
  }

  return (
    <Route {...rest} render={props => (
      auth && auth.isAuthenticated && isAllowed(props.path, auth) ? (
        <Component {...props}/>
      ) : (
        <Redirect to={{
          pathname: unAuthorizedLandingRoute,
          state: { from: props.location }
        }}/>
      )
    )}/>
  )
}

//auth && auth.isAuthenticated && isAllowed(props.path, auth)



// WEBPACK FOOTER //
// ./src/components/common/ProtectedRoute/protectedRoute.js